import GraphQLClient from '../../core/adapter/graphQLClient';
import Order from '../../entity/order';
import Session from '../../entity/session';
import getOrder from './query/getOrder';
import createOrder from './mutation/createOrder';
import buyMutation from './mutation/buy';
import OrderProduct from "../../entity/orderProduct";

class OrderRepository {
  private graphqlClient: GraphQLClient;

  constructor({ graphqlClient }: { graphqlClient: GraphQLClient }) {
    this.graphqlClient = graphqlClient;
  }

  public getOrderWithProducts(session: Session): Promise<{ order: Order, orderProducts: OrderProduct[] }> {
    return this.graphqlClient
      .query(session, getOrder)
      .then(({ data }: { data: any }) => {
        const orderJson = data['orderByStore'];
        const order = Order.fromJson(orderJson);
        const orderProducts = orderJson['productOrders'] ? orderJson['productOrders'].map((value: any) => {
          return OrderProduct.fromJson(value);
        }) : [];

        return {
          order,
          orderProducts,
        }
      });
  }

  public getOrder(session: Session): Promise<Order> {
    return this.graphqlClient
      .query(session, getOrder)
      .then(({ data }: { data: any }) => {
        return Order.fromJson(data['orderByStore']);
      });
  }

  public saveOrder(
    session: Session,
    {
      order,
      orderProducts,
    }: {
      order: Order;
      orderProducts?: OrderProduct[];
    },
  ) {
    const mutation = createOrder;
    const mutationName = 'createOrderForStore';
    return this.graphqlClient
      .mutate(session, mutation, {
        variables: {
          order: order.toJson(orderProducts),
        },
      })
      .then(({ data }: { data: any }) => Order.fromJson(data[mutationName]));
  }

  public buyOrder(
    session: Session,
  ) {
    const mutation = buyMutation;
    const mutationName = 'buyOrderByStore';
    return this.graphqlClient
      .mutate(session, mutation)
      .then(({ data }: { data: any }) => Order.fromJson(data[mutationName]));
  }
}

export default OrderRepository;
